export { default as AdminPageWrapper } from './PageWrapper';
